import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input, Select } from "antd";
import PropTypes from "prop-types";

import { Modals, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import UploadImage from "components/UploadImage";

const Component = ({ data = {}, onUpdate, options: { images = [] } }) => {
	const initialState = { chosenImage: "" };
	const [state, setState] = useState(initialState);
	const { submitting, visible, chosenImage } = state;
	const { id, title } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				const action =
					hash === `#${Modals.CREATE}`
						? API.banner.create(values)
						: API.banner.update(id, values);

				action
					.then(() => {
						onUpdate(null, true);
						navigate(-1);
					})
					.catch(() => {
						setState((prevState) => ({ ...prevState, submitting: false }));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (id) {
					setState((prevState) => ({
						...prevState,
						visible: true,
						chosenImage: data?.cover?.url,
					}));

					form.setFieldsValue({ ...data, coverId: data?.cover?.id });
				} else {
					navigate({ pathname, search }, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Drawer
			className="sp-form-drawer"
			placement={process.env.REACT_APP_IS_RTL ? "left" : "right"}
			footer={
				<>
					<Button
						type="primary"
						onClick={handleSubmit}
						loading={submitting}
					>
						{Resources.confirm}
					</Button>
					<Button
						onClick={() => navigate(-1)}
						disabled={submitting}
					>
						{Resources.cancel}
					</Button>
				</>
			}
			onClose={() => navigate(-1)}
			title={
				hash === `#${Modals.CREATE}`
					? `${Resources.add} ${Resources.banner}`
					: `${Resources.edit} ${Resources.banner} "${title}"`
			}
			maskClosable={false}
			open={visible}
			width={414}
		>
			<Form
				layout="vertical"
				form={form}
			>
				<Form.Item
					name="title"
					label={Resources.title}
					rules={Rules.required}
				>
					<Input />
				</Form.Item>

				<Form.Item
					name="coverId"
					label={Resources.image}
					rules={Rules.required}
				>
					<Select
						options={images}
						optionFilterProp="label"
						onChange={(e, element) => {
							setState((prev) => ({ ...prev, chosenImage: element.file }));
						}}
						showSearch
					/>
				</Form.Item>
				{chosenImage ? (
					<img
						src={chosenImage}
						className="image"
						style={{
							width: "50%",
							objectFit: "cover",
							margin: "0 auto",
							display: "block",
						}}
					/>
				) : (
					""
				)}
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
};

export default Component;
